import React from 'react';

const EquipmentReport = () => {
  const equipmentData = [
    { id: 1, vehicleType: 'Tipper 10 Wheeler', equipmentName: 'TIPPER 10W', equipmentReg: 'AS24C2520' },
    { id: 2, vehicleType: 'Tipper 10 Wheeler', equipmentName: 'TIPPER 10W', equipmentReg: 'AS24C2466' },
    { id: 3, vehicleType: 'Tipper 10 Wheeler', equipmentName: 'TIPPER 10W', equipmentReg: 'AS24C2421' },
    { id: 4, vehicleType: 'Tipper 10 Wheeler', equipmentName: 'TIPPER 10W', equipmentReg: 'AS24C2403' },
    { id: 5, vehicleType: 'Tipper 10 Wheeler', equipmentName: 'TIPPER 10W', equipmentReg: 'AS24C2502' },
    { id: 6, vehicleType: 'Tipper 10 Wheeler', equipmentName: 'TIPPER 10W', equipmentReg: 'AS24C2484' },
    { id: 7, vehicleType: 'Tipper 10 Wheeler', equipmentName: 'TIPPER 10W', equipmentReg: 'AS24C2475' },
    { id: 8, vehicleType: 'Tipper 10 Wheeler', equipmentName: 'TIPPER 10W', equipmentReg: 'AS24C2493' },
  ];

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="min-h-screen bg-white p-4">
      {/* Print Button - Hidden during print */}
      <div className="print:hidden mb-6 text-center">
        <button
          onClick={handlePrint}
          className="bg-black text-white px-6 py-3 text-sm font-medium hover:bg-gray-800 transition-colors"
        >
          Print Report
        </button>
      </div>

      {/* Main Container */}
      <div className="max-w-4xl mx-auto border-2 border-black p-4 print:max-w-none print:mx-0 print:border-2">
        <div className="border border-black p-3">
          
          {/* Header Section */}
          <div className="border border-black p-3 mb-4 flex items-center gap-5">
            {/* Logo Section */}
            <div className="w-28 h-20 bg-black text-white flex flex-col justify-center items-center text-xs font-bold">
              <div>NISSI</div>
              <div>INFOTECH</div>
              <div className="text-xs">PVT LTD</div>
            </div>
            
            {/* Company Info */}
            <div className="flex-1 text-center">
              <h1 className="text-lg font-bold mb-2">Nissi Infotech</h1>
              <div className="text-xs leading-tight">
                <div>Nissi</div>
                <div className="font-semibold">CIVIL CONSTRUCTION</div>
                <div>3/42-12, Nagappa colony , kavundampalayam</div>
                <div>Coimbatore, Tamil Nadu, India</div>
                <div className="mt-1">
                  Phone No :9003744644 &nbsp;&nbsp;&nbsp;&nbsp; infraconsoft-implementation@nissiinfotech.in
                </div>
              </div>
            </div>
          </div>

          {/* Report Title */}
          <div className="text-center text-base font-bold my-4">
            DashBoard Expired Equipment Report
          </div>

          {/* Data Table */}
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border border-black text-xs">
              <thead>
                <tr className="bg-white">
                  <th className="border border-black p-2 text-center font-bold">S.No</th>
                  <th className="border border-black p-2 text-center font-bold">Vehicle Main type</th>
                  <th className="border border-black p-2 text-center font-bold">Equipment Name</th>
                  <th className="border border-black p-2 text-center font-bold">Equipment Reg</th>
                  <th className="border border-black p-2 text-center font-bold">Insurance</th>
                  <th className="border border-black p-2 text-center font-bold">Fc</th>
                  <th className="border border-black p-2 text-center font-bold">Road Tax</th>
                  <th className="border border-black p-2 text-center font-bold">Permit</th>
                  <th className="border border-black p-2 text-center font-bold">Free Service</th>
                  <th className="border border-black p-2 text-center font-bold">Store Name</th>
                </tr>
              </thead>
              <tbody>
                {equipmentData.map((item) => (
                  <tr key={item.id}>
                    <td className="border border-black p-2 text-center">{item.id}</td>
                    <td className="border border-black p-2 text-center">{item.vehicleType}</td>
                    <td className="border border-black p-2 text-center">{item.equipmentName}</td>
                    <td className="border border-black p-2 text-center">{item.equipmentReg}</td>
                    <td className="border border-black p-2 text-center">Expired</td>
                    <td className="border border-black p-2 text-center">Expired</td>
                    <td className="border border-black p-2 text-center">Expired</td>
                    <td className="border border-black p-2 text-center">Expired</td>
                    <td className="border border-black p-2 text-center"></td>
                    <td className="border border-black p-2 text-center">HEAD-OFFICE</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Footer */}
          <div className="mt-4 p-2 border border-black bg-gray-100 text-xs">
            Report generated by ERP-Software - www.infraconsoft.com owned by www.nissiinfotech.com
          </div>
        </div>
      </div>

      {/* Print Styles */}
      <style jsx>{`
        @media print {
          body {
            margin: 0;
            padding: 0;
          }
          
          * {
            -webkit-print-color-adjust: exact !important;
            color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          
          .print\\:hidden {
            display: none !important;
          }
          
          .print\\:max-w-none {
            max-width: none !important;
          }
          
          .print\\:mx-0 {
            margin-left: 0 !important;
            margin-right: 0 !important;
          }
          
          .print\\:border-2 {
            border-width: 2px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default EquipmentReport;